import { Button, ButtonProps, Link } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import AddIcon from '@mui/icons-material/Add'

interface AddButtonProps extends ButtonProps {
  to: string
  state?: string
}

export const AddButton = ({ to, state, ...rest }: AddButtonProps) => {
  return (
    <Link component={RouterLink} to={to} state={state ? state : null}>
      <Button
        variant='contained'
        sx={{ borderRadius: '24px', minWidth: '24px', p: '4px', ml: 2, m: 1 }}
        {...rest}
      >
        <AddIcon />
      </Button>
    </Link>
  )
}
